// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-credits-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 103px;
  }
  .patient-credits-heading {
    margin: 0;
    font: 600 26px Poppins, sans-serif;
  }
  .patient-credits-description {
    margin-top: 4px;
    font: 400 18px Poppins, sans-serif;
    color: #656565;
  }
  .patient-credits-container {
    display: flex;
    flex-direction: column;
    padding: 21.5px 25.5px 22.5px 30.5px;
    border-radius: 12px;
    box-shadow: 0px 0px 7.5px rgba(22, 16, 16, 0.06);
  }
  .credits-heading {
    font: 600 22px Poppins, sans-serif;
  }
  .credit-section-border {
    border-top: 0.2px solid dimgrey;
  }
  .patient-connects-part {
    margin-top: 31.5px;
  }
  .flex-row-with-connects {
    display: flex;
    justify-content: space-between;
    height: 61px;
  }
  .center-column-text-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .patient-info-text {
    margin: 0;
    font: 500 20px Poppins, sans-serif;
  }
  .connect-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .connect-stats-container {
    display: flex;
    justify-content: flex-end;
  }
  .svg-container {
    margin-top: 8px;
    margin-right: 5px;
  }
  .connect-counter {
    font: 400 16px Poppins, sans-serif;
    color: #656565;
  }
  .numeric-list-container {
    margin-top: 6.5px;
  }
  .vertical-text-container {
    width: 100%;
    height: 25px;
  }
  .horizontal-text-list {
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
    margin-top: 5.5px;
  }
  .hierarchical-text {
    margin: 0;
    font: 400 12px Poppins, sans-serif;
    color: #656565;
  }
  .payment-button {
    display: block;
    align-self: flex-end;
    min-width: 252px;
    height: 54px;
    margin-top: 37px;
    font: 600 18px Poppins, sans-serif;
    color: white;
    cursor: pointer;
    background: #ff6036;
    border: none;
    border-radius: 44px;
  }
  .credits .slider {
    background-color: #ff603659;
    border-radius: 10px; /* Remove default appearance */
    appearance: none;
    width: 100%;
    height: 10px;
    outline: none;
    /* Track background */
    background: linear-gradient(
        to right,
        #ff6036 0%,
        #ff6036 var(--slider-value, 0%),
        #ff603659 var(--slider-value, 0%)
      );
    
  }
  
  .credits .slider::-webkit-slider-thumb { /* Remove default thumb */
    appearance: none;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    border: 2px solid white; /* White border */
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3); /* Subtle shadow */
    background: #ff6036;
    cursor: pointer;
  }
  
  .credits .slider::-moz-range-thumb {
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: #ff6036;
    cursor: pointer;
  }
  
  .credits .slider::-webkit-slider-runnable-track {
    background: transparent;
    border-radius: 10px;
  }
  
  .credits .slider::-moz-range-track {
    background: transparent;
    border-radius: 10px;
  }`, "",{"version":3,"sources":["webpack://./src/assets/css/credits.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,kCAAkC;EACpC;EACA;IACE,eAAe;IACf,kCAAkC;IAClC,cAAc;EAChB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,mBAAmB;IACnB,gDAAgD;EAClD;EACA;IACE,kCAAkC;EACpC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,SAAS;IACT,kCAAkC;EACpC;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,aAAa;IACb,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,kCAAkC;IAClC,cAAc;EAChB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,kCAAkC;IAClC,cAAc;EAChB;EACA;IACE,cAAc;IACd,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kCAAkC;IAClC,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,2BAA2B;IAC3B,mBAAmB,EACO,8BAA8B;IACxD,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB;;;;;OAKG;;EAEL;;EAEA,yCAC4B,yBAAyB;IACnD,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uBAAuB,EAAE,iBAAiB;IAC1C,0CAA0C,EAAE,kBAAkB;IAC9D,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;EACrB","sourcesContent":[".patient-credits-section {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-top: 103px;\n  }\n  .patient-credits-heading {\n    margin: 0;\n    font: 600 26px Poppins, sans-serif;\n  }\n  .patient-credits-description {\n    margin-top: 4px;\n    font: 400 18px Poppins, sans-serif;\n    color: #656565;\n  }\n  .patient-credits-container {\n    display: flex;\n    flex-direction: column;\n    padding: 21.5px 25.5px 22.5px 30.5px;\n    border-radius: 12px;\n    box-shadow: 0px 0px 7.5px rgba(22, 16, 16, 0.06);\n  }\n  .credits-heading {\n    font: 600 22px Poppins, sans-serif;\n  }\n  .credit-section-border {\n    border-top: 0.2px solid dimgrey;\n  }\n  .patient-connects-part {\n    margin-top: 31.5px;\n  }\n  .flex-row-with-connects {\n    display: flex;\n    justify-content: space-between;\n    height: 61px;\n  }\n  .center-column-text-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  .patient-info-text {\n    margin: 0;\n    font: 500 20px Poppins, sans-serif;\n  }\n  .connect-card {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n  .connect-stats-container {\n    display: flex;\n    justify-content: flex-end;\n  }\n  .svg-container {\n    margin-top: 8px;\n    margin-right: 5px;\n  }\n  .connect-counter {\n    font: 400 16px Poppins, sans-serif;\n    color: #656565;\n  }\n  .numeric-list-container {\n    margin-top: 6.5px;\n  }\n  .vertical-text-container {\n    width: 100%;\n    height: 25px;\n  }\n  .horizontal-text-list {\n    display: flex;\n    justify-content: space-between;\n    padding-right: 10px;\n    margin-top: 5.5px;\n  }\n  .hierarchical-text {\n    margin: 0;\n    font: 400 12px Poppins, sans-serif;\n    color: #656565;\n  }\n  .payment-button {\n    display: block;\n    align-self: flex-end;\n    min-width: 252px;\n    height: 54px;\n    margin-top: 37px;\n    font: 600 18px Poppins, sans-serif;\n    color: white;\n    cursor: pointer;\n    background: #ff6036;\n    border: none;\n    border-radius: 44px;\n  }\n  .credits .slider {\n    background-color: #ff603659;\n    border-radius: 10px;\n    -webkit-appearance: none; /* Remove default appearance */\n    appearance: none;\n    width: 100%;\n    height: 10px;\n    outline: none;\n    /* Track background */\n    background: linear-gradient(\n        to right,\n        #ff6036 0%,\n        #ff6036 var(--slider-value, 0%),\n        #ff603659 var(--slider-value, 0%)\n      );\n    \n  }\n  \n  .credits .slider::-webkit-slider-thumb {\n    -webkit-appearance: none; /* Remove default thumb */\n    appearance: none;\n    width: 30px;\n    height: 30px;\n    border-radius: 50%;\n    border: 2px solid white; /* White border */\n    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.3); /* Subtle shadow */\n    background: #ff6036;\n    cursor: pointer;\n  }\n  \n  .credits .slider::-moz-range-thumb {\n    width: 18px;\n    height: 18px;\n    border-radius: 50%;\n    background: #ff6036;\n    cursor: pointer;\n  }\n  \n  .credits .slider::-webkit-slider-runnable-track {\n    background: transparent;\n    border-radius: 10px;\n  }\n  \n  .credits .slider::-moz-range-track {\n    background: transparent;\n    border-radius: 10px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
